module.exports = __webpack_public_path__ + "img/support.fdc646c2.svg";